import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

export type cardFlag = 'VISA' | 'MASTERCARD' | 'AMEX' | 'UNKNOWN';

@Component({
  selector: 'umkt-credit-card-item',
  standalone: true,
  imports: [TitleCasePipe],
  templateUrl: './credit-card-item.component.html',
  styleUrl: './credit-card-item.component.scss'
})
export class CreditCardItemComponent implements OnInit {
  @Input({ required: true }) cardFlag!: cardFlag;
  @Input({ required: true }) lastFourDigits!: string;

  public cardIconPath: string = '';

  ngOnInit(): void {
    this.lastFourDigits = this.lastFourDigits.replace(/\D/g,'');

    if (this.lastFourDigits && this.lastFourDigits.length > 4) {
      this.lastFourDigits = this.lastFourDigits.slice(-4);
    }

  }

}
